var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDanger = function SvgDanger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.442 15.953 15.436 3.978a3.974 3.974 0 0 0-6.873 0l-7.008 11.98a4.007 4.007 0 0 0 3.419 6.04h14.038a4.005 4.005 0 0 0 3.43-6.045m-19.164 1.02 7.013-11.988a1.976 1.976 0 0 1 3.416-.003l7.01 11.985a2.007 2.007 0 0 1-1.714 3.031H4.983a2.004 2.004 0 0 1-1.705-3.024M12 17.999a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1.004-10h-2.001v7h2z",
    clipRule: "evenodd"
  })));
};
export default SvgDanger;